export const FETCH_FEATURE_FLAGS_SUCCESS = 'hall/featureFlags/FETCH_SUCCESS'
export const FETCH_FEATURE_FLAGS_ERROR = 'hall/featureFlags/FETCH_ERROR'
export const CLEAR_FEATURE_FLAGS = 'hall/featureFlags/CLEAR'
